@if (!selectedImage()) {
<button type="button"
        class="btn btn-default btn-sm p-0 browse-button"
        [class.file-browser-button]="iconOnly()"
        title="Browse"
        (click)="openFileBrowser()"
        [disabled]="disabled()">
  <i [class]="defaultIcon()"></i> {{!iconOnly() ? 'Browse' : '' }}
</button>
}

@if (selectedImage()) {
<div class="selected-image-wrapper">
  @if (isSelectedVideo()) {
  <video
         [src]="selectedImage()"
         class="selected-image selected-video"
         (click)="openFileBrowser()"
         [style.maxWidth]="imageWidth()"
         [style.maxHeight]="imageHeight()"
         controls
         muted
         preload="metadata"></video>
  } @else {
    <img [src]="selectedImage()" class="selected-image" (click)="openFileBrowser()" [style.maxWidth]="imageWidth()" [style.maxHeight]="imageHeight()" />
  }
  <ng-template #imagePreview>
    <img [src]="selectedImage()" class="selected-image" (click)="openFileBrowser()" [style.maxWidth]="imageWidth()" [style.maxHeight]="imageHeight()" />
  </ng-template>
  <span class="delete-indicator" (click)="!disabled() && clearImage()">&times;</span>
</div>
}

<ng-template #browserModal let-modal>
  <app-iframe-modal-shell
    [src]="browserUrl"
    [dismissLoadingOnLoad]="true"
    initialTitle="File browser"
    (close)="modal.dismiss('cancel')">
  </app-iframe-modal-shell>
</ng-template>
